import { fieldAppliesToCart } from './fieldAppliesToCart';

export const isPerTicket = (customFieldValue) => customFieldValue?.custom_field?.ask_per === 'ticket';

const ticketKey = (value) => (value === undefined || value === null || value === '' ? null : Number(value));

export const sameAnswer = (a, b) => (
  a.custom_field.id === b.custom_field.id
  && ticketKey(a.ticket_type_id) === ticketKey(b.ticket_type_id)
  && ticketKey(a.ticket_index) === ticketKey(b.ticket_index)
);

export const replaceOrAddAnswer = (answers, answer) => (
  answers.some((existing) => sameAnswer(existing, answer))
    ? answers.map((existing) => (sameAnswer(existing, answer) ? answer : existing))
    : [...answers, answer]
);

export const ticketAnswerBlocks = (answers = [], ticketTypes = []) => {
  const questions = answers.filter((answer) => isPerTicket(answer) && ticketKey(answer.ticket_type_id) === null);
  if (questions.length === 0) return [];

  let number = 0;
  return ticketTypes.flatMap((ticketType) => {
    const quantity = Math.max(parseInt(ticketType.quantity || 0, 10) || 0, 0);

    return Array.from({ length: quantity }, (_, ticketIndex) => {
      number += 1;
      const ticketAnswers = questions
        .filter((question) => fieldAppliesToCart(question.custom_field, [{ id: ticketType.id, quantity: 1 }]))
        .map((question) => {
          const slot = { ...question, id: null, ticket_type_id: ticketType.id, ticket_index: ticketIndex };
          return answers.find((answer) => sameAnswer(answer, slot)) || slot;
        });

      return {
        key: `${ticketType.id}-${ticketIndex}`,
        label: `Ticket ${number} · ${ticketType.name}`,
        answers: ticketAnswers,
      };
    });
  }).filter((block) => block.answers.length > 0);
};

export const checkoutAnswers = (answers = [], ticketTypes = []) => {
  const orderAnswers = answers.filter((answer) => !isPerTicket(answer) && fieldAppliesToCart(answer.custom_field, ticketTypes));
  const blocks = ticketAnswerBlocks(answers, ticketTypes);

  return { orderAnswers, blocks, all: [...orderAnswers, ...blocks.flatMap((block) => block.answers)] };
};
